import { render, staticRenderFns } from "./PortalIcon.vue?vue&type=template&id=4b31a0f5&"
import script from "./PortalIcon.vue?vue&type=script&lang=ts&"
export * from "./PortalIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports